import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overview-card-ghost',
  templateUrl: './overview-card-ghost.component.html',
  styleUrls: ['./overview-card-ghost.component.css']
})
export class OverviewCardGhostComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
